import React from 'react';

/**
 * Compact "About the data" panel for the header.
 *
 * Sits beside the wordmark on desktop and stacks below it on mobile - the
 * stacking is done in App.css (.header-about), because the header has no
 * other breakpoint rules and this is the first element that needs one.
 *
 * Wording is deliberately careful:
 *   - the venue set is generated by periodic script runs, not fetched live,
 *     so it does not claim to be current;
 *   - "sufficiently reliable location data" describes the geocoder's actual
 *     accept/reject behaviour. It does not promise verification;
 *   - no claim is made about which regions are best covered, because that
 *     has not been measured.
 *
 * The fuller text lives at /about.html - a static page in public/, since the
 * app has no router.
 */
export default function AboutData() {
  return (
    <aside
      className="header-about"
      aria-label="About the data"
      style={{
        maxWidth: '22rem',
        padding: '0.75rem 0.875rem',
        borderRadius: '0.5rem',
        border: '1px solid rgba(255,255,255,0.14)',
        backgroundColor: 'rgba(255,255,255,0.06)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: '0.75rem',
          fontWeight: '700',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.72)'
        }}
      >
        About the data
      </h2>

      <p
        style={{
          margin: '0.4rem 0 0',
          fontSize: '0.8125rem',
          lineHeight: 1.45,
          color: 'rgba(255,255,255,0.78)'
        }}
      >
        Coverage varies by country and division, and some leagues may be
        incomplete. Stadiums are included only when sufficiently reliable
        location data is available. Where several clubs share a stadium, they
        are shown together on one pin. Venue information may change, so please
        confirm important details with official sources before travelling.
      </p>

      <a
        href="/about.html"
        style={{
          display: 'inline-block',
          marginTop: '0.5rem',
          fontSize: '0.8125rem',
          fontWeight: '600',
          color: 'rgba(255,255,255,0.92)',
          textDecoration: 'underline',
          textUnderlineOffset: '0.15em'
        }}
      >
        More information
      </a>
    </aside>
  );
}
